/**
 * 1688 Purchase Assistant Plugin
 *
 * Exposes no reachable web-accessible resource, but its content script injects
 * vendor-namespaced elements into every page: `<div id="market-mate-for-1688">` and a
 * `<style id="market-mate-selection-bubble-font">`. Found with
 * `tooling/probe-interactions.js` — they appeared on a plain bait page with no user
 * action. (It also injects a randomly-named `<div id="au…">`, which is unmatchable and
 * ignored here.)
 *
 * The `market-mate-for-1688` id is vendor- and product-specific, so it identifies this
 * extension rather than "some shopping assistant". Behavioural, so it only fires while
 * the content script is active.
 *
 * Observed on version 1.1.5.
 */

import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kphldkppgfpjadpabfkghmjbhpcmgpdg';

export const purchaseAssistant1688: ExtensionDefinition = {
  id: ID,
  name: '1688 Purchase Assistant Plugin',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Detected behaviourally: injects #market-mate-for-1688 and a market-mate-namespaced ' +
    '<style>. No reachable web-accessible resource, so these are the signals.',
  signals: [
    {
      id: 'dom-market-mate-container',
      kind: 'dom',
      description:
        'Look for #market-mate-for-1688 — the vendor-namespaced container the extension ' +
        'injects into every page while its content script is active.',
      weight: 1,
      run: () => probeSelector('#market-mate-for-1688', { timeoutMs: 2500 }),
    },
    {
      id: 'dom-market-mate-font-style',
      kind: 'dom',
      description:
        'Look for style#market-mate-selection-bubble-font — a second market-mate-namespaced ' +
        'element, corroborating the identification.',
      weight: 0.5,
      run: () => probeSelector('style#market-mate-selection-bubble-font', { timeoutMs: 2500 }),
    },
  ],
};
